export enum UserRoleEnum {
	ADMIN = 'ADMIN',
	USER = 'USER'
}